// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3zRMB","dragIcon":"SortableItem_dragIcon__2QZTw","disabled":"SortableItem_disabled__q1Qbp"};